import { render, staticRenderFns } from "./home_mobile.vue?vue&type=template&id=12b2ccae&scoped=true"
import script from "./home_mobile.vue?vue&type=script&lang=js"
export * from "./home_mobile.vue?vue&type=script&lang=js"
import style0 from "./home_mobile.vue?vue&type=style&index=0&id=12b2ccae&prod&lang=scss&scoped=true"
import style1 from "./home_mobile.vue?vue&type=style&index=1&id=12b2ccae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b2ccae",
  null
  
)

export default component.exports